import React, { Component } from 'react';

class FAQ extends Component {
    componentDidMount() {
        document.title = "Addiction | FAQ"
    }

    render() {
        return (
            <div>
                <h1>Frequently Asked Questions</h1>
                <div className="panel-adt">
                    <h2>What timezone does Addiction operate in?</h2>
                    <p>Addiction is primarily a North American guild. However, we have members from across the globe who fit their schedules to our time zones. Our standard raid time is 6PST/9EST to allow both West and East coast players to raid while avoiding awkward late hours, or before-work starts.</p>
                </div>
                <div className="panel-adt">
                    <h2>How large is Addiction</h2>
                    <p>Addiction is a multi-game guild, and thus each game will require a different maximum number of members. Our roster sizes range from 30 to 150. Because of large roster sizes, and the relative small size of PvE raids, we run multiple PvE raids a night in sections with large member bases.</p>
                </div>
                <div className="panel-adt">
                    <h2>What type of DKP system does Addiction use?</h2>
                    <p>This is game dependent, however the Addiction standard is a standard DKP system where points are earned based on time spent attending a raid, and mob kills. Items are purchased through an anonymous bid system in increments of 5 points. Members are not allowed to spend DKP they do not have.</p>
                </div>
                <div className="panel-adt">
                    <h2>How do I join Addiction?</h2>
                    <p>First register an account on our website. Second sign in and begin the application process in your User Control Panel. You will have to regularly check our website for updates on your application process. Email updates are unreliable and we no longer use them.</p>
                </div>
            </div>
        )
    }
}


export default FAQ;


// WEBPACK FOOTER //
// ./src/About/FAQ.js